import { render, staticRenderFns } from "./sousuo.vue?vue&type=template&id=b610ede6&scoped=true&"
import script from "./sousuo.vue?vue&type=script&lang=js&"
export * from "./sousuo.vue?vue&type=script&lang=js&"
import style0 from "./sousuo.vue?vue&type=style&index=0&id=b610ede6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b610ede6",
  null
  
)

export default component.exports